import { useQueries } from "@tanstack/react-query";
import { apiRequest } from "../hooks/apiRequest";
import { taskKeys } from "../utils/queryKeys";
import { TaskProps, ProjectProps } from "../types/interfaces";

/**
 * Composition only — no new endpoints, no new shapes. Fans `useTasks` out over
 * the projects the user can see so the home dashboard can answer "my open
 * tasks" and "overdue" without a bespoke API.
 */
export function useTasksAcrossProjects(projects: ProjectProps[] | undefined) {
  const list = projects || [];
  const results = useQueries({
    queries: list.map((p) => ({
      queryKey: taskKeys.list({ projectId: p._id }),
      queryFn: async () => (await apiRequest<TaskProps[]>(`tasks?projectId=${p._id}`)).data,
      enabled: !!p._id,
    })),
  });

  return {
    isLoading: results.some((r) => r.isLoading),
    isError: results.some((r) => r.isError),
    error: results.find((r) => r.isError)?.error,
    tasks: results.flatMap((r) => r.data || []),
    projectOf: (task: TaskProps) => list.find((p) => p._id === task.projectId),
  };
}
